import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "groups", "renderItem", "getGroupKey", "getGroupLabel", "getItemAttributes", "getItemChecked", "getItemDescription", "getItemDisabled", "getItemGroupKey", "getItemRightSide", "getItemTagName", "getItemKey", "getItemLabel", "getItemLeftSide", "getItemOnClick", "getItemRef", "onItemClick", "className", "motion", "invert"];
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
import { useList } from "./hooks/useList";
import { composePreparedProps } from "./utils";
import { ListItem } from "./ListItem";
import { ListGroup } from "./ListGroup";
import { MotionComponent } from "../MotionComponent";
var cnList = cnBem('list', styles);
var ListRender = function ListRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    items = _composePreparedProps.items,
    groups = _composePreparedProps.groups,
    renderItem = _composePreparedProps.renderItem,
    getGroupKey = _composePreparedProps.getGroupKey,
    getGroupLabel = _composePreparedProps.getGroupLabel,
    getItemAttributes = _composePreparedProps.getItemAttributes,
    getItemChecked = _composePreparedProps.getItemChecked,
    getItemDescription = _composePreparedProps.getItemDescription,
    getItemDisabled = _composePreparedProps.getItemDisabled,
    getItemGroupKey = _composePreparedProps.getItemGroupKey,
    getItemRightSide = _composePreparedProps.getItemRightSide,
    getItemTagName = _composePreparedProps.getItemTagName,
    getItemKey = _composePreparedProps.getItemKey,
    getItemLabel = _composePreparedProps.getItemLabel,
    getItemLeftSide = _composePreparedProps.getItemLeftSide,
    getItemOnClick = _composePreparedProps.getItemOnClick,
    getItemRef = _composePreparedProps.getItemRef,
    onItemClick = _composePreparedProps.onItemClick,
    className = _composePreparedProps.className,
    motion = _composePreparedProps.motion,
    invert = _composePreparedProps.invert,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var _useList = useList({
      items: items,
      groups: groups,
      getGroupKey: getGroupKey,
      getItemGroupKey: getItemGroupKey
    }),
    listItems = _useList.listItems;
  var renderItemDefault = function renderItemDefault(item) {
    var _getItemAttributes;
    var handleClick = function handleClick(e) {
      var _getItemOnClick;
      (_getItemOnClick = getItemOnClick(item)) === null || _getItemOnClick === void 0 ? void 0 : _getItemOnClick(e);
      onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(item, e);
    };
    return /*#__PURE__*/React.createElement(ListItem, _extends({
      checked: getItemChecked(item),
      description: getItemDescription(item),
      disabled: getItemDisabled(item),
      invert: invert,
      label: getItemLabel(item),
      leftSide: getItemLeftSide(item),
      onClick: handleClick,
      ref: getItemRef(item),
      rightSide: getItemRightSide(item),
      tagName: getItemTagName(item)
    }, (_getItemAttributes = getItemAttributes(item)) !== null && _getItemAttributes !== void 0 ? _getItemAttributes : {}, {
      "data-t-id": "modules-List"
    }));
  };
  return /*#__PURE__*/React.createElement(MotionComponent, _extends({}, otherProps, {
    className: cnList(null, [className]),
    motion: motion,
    ref: ref,
    tagName: "ul"
  }), listItems.map(function (item) {
    var key = item.type === 'group' ? getGroupKey(item.element) : getItemKey(item.element);
    return /*#__PURE__*/React.createElement(MotionComponent, _extends({
      key: "".concat(item.type, "-").concat(key),
      tagName: "li"
    }, item.type === 'item' ? {
      role: 'option',
      'aria-selected': getItemChecked(item.element)
    } : {
      role: 'group'
    }, motion ? {
      motion: true,
      layout: true
    } : {}), item.type === 'item' ? (renderItem || renderItemDefault)(item.element) : /*#__PURE__*/React.createElement(ListGroup, {
      className: cnList('group')
    }, getGroupLabel(item.element)));
  }));
};
export var List = /*#__PURE__*/forwardRef(ListRender);